import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export type PortalRole = 'ADMIN' | 'OPS' | 'TINYPROMO_OPS';

export interface PortalMe {
  userId: string;
  email: string;
  role?: PortalRole;
  portalOperator: boolean;
}

@Injectable({ providedIn: 'root' })
export class PortalRoleService {
  private readonly base = `${environment.apiUrl}/admin-center/ops-royal/v1`;
  private readonly PORTAL_ME = 'portal_me';
  private me: PortalMe | null = null;

  constructor(private http: HttpClient) {}

  async loadMe(): Promise<PortalMe | null> {
    const token = localStorage.getItem('id_token');
    if (!token) {
      this.clear();
      return null;
    }
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + token,
      Accept: 'application/json',
    });
    try {
      this.me = await this.http.get<PortalMe>(`${this.base}/me`, { headers }).toPromise();
      if (this.me) {
        localStorage.setItem(this.PORTAL_ME, JSON.stringify(this.me));
      }
      return this.me;
    } catch (e) {
      this.clear();
      return null;
    }
  }

  getMe(): PortalMe | null {
    if (this.me) {
      return this.me;
    }
    const raw = localStorage.getItem(this.PORTAL_ME);
    if (!raw) {
      return null;
    }
    try {
      this.me = JSON.parse(raw);
      return this.me;
    } catch {
      return null;
    }
  }

  isAdmin(): boolean {
    return this.getMe()?.role === 'ADMIN';
  }

  isOps(): boolean {
    return this.getMe()?.role === 'OPS';
  }

  isTinyPromoOps(): boolean {
    return this.getMe()?.role === 'TINYPROMO_OPS';
  }

  clear(): void {
    this.me = null;
    localStorage.removeItem(this.PORTAL_ME);
  }
}
